// Import and register all your controllers from the importmap under controllers/*

import { application } from 'stimulus/application'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'

// Eagerly load every controller except the heavy ones below, which are split
// into their own chunks and registered lazily only on pages that use them.
const context = require.context(
  './controllers',
  true,
  /^\.\/(?!setup_integration_controller\.js$|animated_sources_controller\.js$).*\.js$/
)
application.load(definitionsFromContext(context))

const lazyControllers = {
  'setup-integration': () =>
    import('./controllers/setup_integration_controller'),
  'animated-sources': () => import('./controllers/animated_sources_controller')
}

Object.entries(lazyControllers).forEach(([identifier, load]) => {
  if (document.querySelector(`[data-controller~="${identifier}"]`)) {
    load().then(module => application.register(identifier, module.default))
  }
})
